import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { configureAxios } from './utility/AxiosHelper';

//subir configurações pré definidas do axios.
configureAxios()

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);



serviceWorker.register();
